export default __webpack_public_path__ + "static/media/TourGuidePage_03.038fd7c5.jpg";